module.exports = __webpack_public_path__ + "static/media/team_history_title_icon.794f1b13.png";